import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAppSelector } from '../store/hooks';

export default function ProtectedRoute({ children }) {
  const isLogin = useAppSelector((state) => state.user.isLogin);

  if (!isLogin) {
    return <Navigate to="/login" replace />;
  }

  return children;
}

